const SEO_REL_BLOCK = new Set(['nofollow', 'sponsored', 'ugc']);

/**
 * Drops crawlers-blocking rel values only on anchors that point internally (parity with maison).
 */
export function stripSeoRelFromInternalAnchors(html) {
  if (typeof document === 'undefined' || !html || typeof html !== 'string') return html;
  const base =
    typeof window !== 'undefined' ? String(window.location?.origin || '').replace(/\/$/, '') : '';
  const div = document.createElement('div');
  div.innerHTML = html;

  div.querySelectorAll('a[href]').forEach((a) => {
    const href = (a.getAttribute('href') || '').trim();
    if (!href) return;
    let internal = false;
    if (href.startsWith('/') || href.startsWith('#') || href.startsWith('?')) {
      internal = true;
    } else if (base && (href === base || href.startsWith(`${base}/`))) {
      internal = true;
    } else if (!/^[a-z][a-z0-9+.-]*:/i.test(href)) {
      internal = true;
    }
    if (!internal) return;
    const rel = a.getAttribute('rel');
    if (!rel) return;
    const parts = rel
      .split(/\s+/)
      .map((p) => p.trim())
      .filter((x) => x && !SEO_REL_BLOCK.has(x.toLowerCase()));
    if (parts.length) a.setAttribute('rel', parts.join(' '));
    else a.removeAttribute('rel');
  });

  return div.innerHTML;
}
